import { render, staticRenderFns } from "./editBrand.vue?vue&type=template&id=5a66b2d8"
import script from "./editBrand.vue?vue&type=script&lang=ts"
export * from "./editBrand.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports